<template>
    <tr v-if="collapseActive" class="module__edit_versions_table_item_collapse_table">
        <td class="module__edit_versions_table_item_collapse_table_wrapper" colspan="3">
            <div class="module__edit_versions_table_item_collapse_table_wrapper_content">
                <component-text v-html="item.releaseNotes"></component-text>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentText from '@/components/default/shared/ComponentText'
export default {
  name: 'module-edit-versions-table-item-collapse-table',
  components: { ComponentText },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleaddeditversionstableitemcollapsetable";
</style>
